<template>
  <b-modal
    id="complete-with-note-modal"
    dialog-class="complete-trip-modal"
    @hide="resetPayload"
    :no-close-on-backdrop="true"
  >
    <div class="complete-with-note-modal px-4">
      <div class="d-flex align-items-center border-bottom border-info pb-3">
        <img
          src="@/assets/images/icons/confirm-with-note-icon.svg"
          alt="popup vehicle"
          class="me-2"
        />
        <h4 class="m-0">{{ $t("confirmation-with-note") }}</h4>
      </div>
      <b-alert
        :show="error && error.length ? true : false"
        variant="danger"
        class="mt-3"
      >
        <div v-if="Array.isArray(error)">
          <div
            class="d-flex flex-column my-1"
            v-for="(error_text, index) in error"
            :key="index"
          >
            {{ error_text }}
          </div>
        </div>
        <div v-else>
          <div v-html="error || '&nbsp;'"></div>
        </div>
      </b-alert>
      <div class="mt-3">
        <div class="desc-sm mb-1">
          {{ $t("complete-with-note-question", { id }) }}
        </div>
      </div>

      <div class="mt-4">
        <validation-observer ref="observer">
          <div class="row mb-2">
            <div class="col-12">
              <base-input
                type="number"
                label="allowance-amount-max"
                name="allowance-amount-max"
                placeholder="allowance-amount-max"
                id="service-allowance-amount-complete-note"
                field="serviceAllowance"
                :value="formattedAmount(serviceAllowance)"
                :disabled="true"
              />
            </div>
            <div class="col-12">
              <base-input
                type="number"
                label="allowance-amount"
                name="allowance-amount"
                placeholder="allowance-amount"
                :rules="{
                  required: true,
                  min_value: 0,
                  maxValue: serviceAllowance,
                  decimalDigits: 2,
                }"
                :is_required="true"
                id="allowance-amount-complete-note"
                field="allowanceAmount"
                :value="payload.allowanceAmount"
                @change-value="setValue"
              />
            </div>
            <div class="col-12">
              <base-select
                name="reason"
                rules="required"
                label="reason"
                :is_required="true"
                :options="reasonList"
                field="reason"
                :value="payload.reason"
                @change-value="setValue"
                :useI18n="true"
              ></base-select>
            </div>
            <div class="col-12">
              <base-textarea
                :value="payload.note"
                label="note"
                placeholder="note"
                field="note"
                name="note"
                @change-value="setValue"
              />
            </div>
          </div>
        </validation-observer>
      </div>
      <div class="row justify-content-end align-items-center">
        <div class="col-3 mb-3">
          <base-button
            variant="secondary"
            @click="hideModal"
            :disabled="loading"
          >
            {{ $t("cancel") }}
          </base-button>
        </div>
        <div class="col-3 mb-3">
          <base-button variant="primary" @click="submit" :loading="loading">
            {{ $t("confirm") }}
          </base-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import TripService from "@/services/trip.service";

export default {
  emits: ["updateTrip"],
  props: ["id", "serviceAllowance"],
  data() {
    return {
      loading: false,
      error: null,
      payload: {
        reason: null,
        note: null,
        allowanceAmount: this.serviceAllowance,
      },
      reasonList: [
        {
          value: "The client did not show up",
          text: "client-did-not-show-up",
        },
        {
          value: "The client change the pickup time",
          text: "client-change-pickup-time",
        },
        {
          value: "The client change the pickup location",
          text: "client-change-pickup-location",
        },
        {
          value: "The client change the drop off location",
          text: "client-change-drop-off-time",
        },
        {
          value: "Others",
          text: "others",
        },
      ],
    };
  },
  methods: {
    async submit() {
      const valid = await this.$refs.observer.validate();
      if (!valid) return;
      else {
        this.loading = true;
        this.error = null;

        const data = { reason: this.payload?.reason, id: this.id, allowanceAmount: Number(this.payload?.allowanceAmount) };
        if (this.payload?.note) {
          data.note = this.payload?.note;
        }

        TripService.put(data, "complete-note")
          .then(() => {
            this.$emit("updateTrip");
            this.$bvModal.hide("complete-with-note-modal");
          })
          .catch(({ message }) => {
            this.error = message;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    setValue(val, field) {
      this["payload"][field] = val;
    },
    resetPayload() {
      this.error = null;
      this.payload = {
        reason: null,
        note: null,
      };
    },
    hideModal() {
      this.$bvModal.hide('complete-with-note-modal')
      this.payload.allowanceAmount = this.serviceAllowance;
    },
  },
  i18n: {
    messages: {
      en: require("@/services/i18n/locales/en/reservationOperations.json"),
      ar: require("@/services/i18n/locales/ar/reservationOperations.json"),
    },
  },
};
</script>

<style lang="scss" scoped>
.complete-with-note-modal {
  padding: 3rem 0rem 1rem;
  .modal-content {
    width: 740px;
  }
}
</style>
<style lang="scss">
.complete-trip-modal {
  .modal-content {
    width: 550px;
  }
}
</style>
